import { BmweColumnMeta, DateRangeValue, NumberRangeValue } from '../../types';
import {
  EMPTY_FILTER_VALUE,
  toEuro,
  toReadableDateString,
  toTextFilterValue,
} from '../../helper';
import { commonStrings } from '../../i18n';
import { tableStrings } from './i18n/de-de';

const describeRange = (from?: string, to?: string) => {
  if (from && to) return `${from} – ${to}`;
  if (from) return tableStrings.filter.since(from);
  if (to) return tableStrings.filter.until(to);
  return undefined;
};

const formatNumber = (value: number | undefined, currency: boolean) => {
  if (value === undefined || value === null) return undefined;
  return currency ? String(toEuro(value)) : value.toLocaleString('de-DE');
};

export function describeFilterValue(
  meta: BmweColumnMeta | undefined,
  value: unknown,
): string | undefined {
  if (value === undefined || value === null) return undefined;

  switch (meta?.filterType ?? meta?.dataType) {
    case 'date':
      return toReadableDateString(value as string | Date);
    case 'dateRange': {
      const { from, to } = value as DateRangeValue;
      return describeRange(
        toReadableDateString(from),
        toReadableDateString(to),
      );
    }
    case 'numberRange':
    case 'currency': {
      const { min, max } = value as NumberRangeValue;
      const currency = (meta?.filterType ?? meta?.dataType) === 'currency';
      return describeRange(
        formatNumber(min, currency),
        formatNumber(max, currency),
      );
    }
    case 'boolean':
      if (typeof value !== 'boolean') return undefined;
      return value ? commonStrings.words.yes : commonStrings.words.no;
  }

  const { values, texts } = toTextFilterValue(value);
  const labelOf = (v: string) =>
    v === EMPTY_FILTER_VALUE
      ? tableStrings.filter.emptyOptionLabel
      : (meta?.filterOptions?.find((o) => o.value === v)?.label ?? v);
  const parts = [...values.map(labelOf), ...texts.map((t) => `„${t}“`)];
  return parts.length > 0 ? parts.join(', ') : undefined;
}
